export default {
  name: 'services',
  props: {
    msg: String
  }
}